import { useFormContext } from 'react-hook-form';
import { ICreditCardFormData } from '../ICreditCardFormData';

export function useCreditCardFormContext() {
	return useFormContext<ICreditCardFormData>();
}
